// One-use, in-memory state for returning from the booking form.
let pendingState = null

export function saveSearchReturnState (state) {
  pendingState = state
}

export function takeSearchReturnState () {
  const state = pendingState
  pendingState = null
  return state
}

export function clearSearchReturnState () {
  pendingState = null
}



// WEBPACK FOOTER //
// ./src/pages/newPages/booking/components/smartHotelSearch/searchReturnState.js